import { IError } from '../../../common/error/IError';
import { handleUnauthorizedError } from './handleUnauthorizedError';

export class RestErrorHandler {
  handle = (errorResponse: any) => {
    handleUnauthorizedError(errorResponse);

    if (errorResponse?.json?.webCode) {
      const json = errorResponse.json;
      json.webCode = String(json.webCode);
      throw json;
    } else {
      const unknownError: IError = {
        data: {},
        systemCode: 'unknown',
        webCode: '500',
        message: errorResponse.message || 'Ошибка сервера',
      };

      throw unknownError;
    }
  };
}
